import { render } from "./PasswdBox.vue?vue&type=template&id=5ce8a13c"
import script from "./PasswdBox.vue?vue&type=script&lang=js"
export * from "./PasswdBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__